// @flow

import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import {Icon} from 'react-fa';
import Alert from 'react-s-alert';
import ReactQuill from 'react-quill';
import _ from 'lodash';

import type { Element } from 'react';

import 'react-quill/dist/quill.snow.css';

import {no_rclick, takeDir, noop} from './utils.js';
import App from './App.jsx';
import Map from './Map.jsx';

import type {T_Obs, T_ErrOk} from './types.js';

import './css/DialogNota.css';



type T_DialogNotaProps = {
  obs: T_Obs,
  app: App
};



type T_DialogNotaState = {
  titulo_error: string,
  new         : boolean
};



const MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    ['image'],
  ]
};


const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet', 'indent', 'image'];



export default class DialogNota extends Component<T_DialogNotaProps, T_DialogNotaState> {
  save           : () => void;
  quill_changed  : (string) => void;
  set_title      : (ev: SyntheticInputEvent<*>) => void;
  change_readonly: () => void;
  close          : () => void;
  
  marker: Object;
  
  
  
  constructor(props: T_DialogNotaProps) {
    super(props);
    
    this.state = {
      titulo_error: '',
      new         : props.obs.nota === ''
    };
    
    this.quill_changed   = this.quill_changed.bind(this);
    this.save            = this.save.bind(this);
    this.set_title       = this.set_title.bind(this);
    this.change_readonly = this.change_readonly.bind(this);
    this.close           = this.close.bind(this);
    
    this.props.app.dialog_nota = this;
  }
  
  
  
  set_marker(): void {
    if (Map.google != null && this.marker == null) {
      const google_lib = Map.google;
      
      this.marker = new google_lib.Marker({
        position : {lat: parseFloat(this.props.obs.lat), lng: parseFloat(this.props.obs.lng)},
        map      : this.props.app.map_ui.map.map,
        draggable: this.props.obs.cambios,
        title    : this.props.obs.titulo
      });
      
      this.marker.setMap(this.props.app.map_ui.map.map);
      
      google_lib.event.addListener(this.marker, 'dragend', (ev) => {
        const new_obs = _.cloneDeep(this.props.app.state.obs);
        
        if (new_obs != null) {
          new_obs.lat = ev.latLng.lat();
          new_obs.lng = ev.latLng.lng();
          
          this.props.app.setState({obs: new_obs});
        }
      });
    }
  }
  
  
  
  componentDidMount() {
    this.set_marker();
  }
  
  
  
  componentWillUnmount() {
    if (this.marker != null) {
      this.marker.setMap(null);
    }
    
    this.props.app.dialog_nota = null;
  }
  
  
  
  componentWillReceiveProps(newProps: T_DialogNotaProps) {
    const {obs} = this.props;
    
    if ((newProps.obs.titulo !== obs.titulo) || (newProps.obs.cambios !== obs.cambios) || (newProps.obs.nota !== obs.nota)) {
      this.setState({
        titulo_error: '',
      });
    }
  }
  
  
  
  save(): void {
    const {app} = this.props;
    
    if (app.state.obs != null && app.state.obs.titulo !== '' && app.state.obs.nota !== '') {
      const {obs} = app.state,
            dir   = takeDir(obs.path);
      
      app.post_json(obs, obs.path, (result_post: T_ErrOk) => {
        if (result_post.error) {
          Alert.error('No se pudo crear el punto de observación.');
          console.log(result_post);
        }
        else {
          this.close();
          app.reload_dir(dir, noop);
        }
      });
    }
    else {
      Alert.error('Ingrese título y una nota');
      
      if (app.state.obs != null && app.state.obs.titulo === '') {
        this.setState({titulo_error: 'Título incompleto'});
      }
    }
  }
  
  
  
  close(): void {
    if (this.props.app.state.obs != null) {
      const item_obs = this.props.app.get_item_obs(this.props.app.state.obs.path);
      
      if (item_obs != null) {
        item_obs.close();
      }
    }
    
    this.props.app.setState({obs: null});
  }
  
  
  
  quill_changed(nota: string): void {
    const new_obs = _.cloneDeep(this.props.app.state.obs);
    
    if (new_obs != null) {
      new_obs.nota = nota;
      
      this.props.app.setState({obs: new_obs});
    }
  }
  
  
  
  set_title(ev: SyntheticInputEvent<*>): void {
    const new_obs = _.cloneDeep(this.props.app.state.obs);
    
    if (new_obs != null) {
      new_obs.titulo = ev.target.value;
      
      this.props.app.setState({obs: new_obs}, () => {
        if (this.props.app.state.obs != null && this.props.app.state.obs.titulo !== '') {
          this.setState({titulo_error: ''});
        }
      });
    }
  }
  
  
  
  change_readonly(): void {
    const new_obs = _.cloneDeep(this.props.app.state.obs);
    
    if (new_obs != null) {
      new_obs.cambios = ! this.props.obs.cambios;
      
      this.props.app.setState({obs: new_obs});
    }
  }
  
  
  
  show_nota(): Element<string> {
    return (
      <div onContextMenu={no_rclick} className='nota_dialog'>
        <p className='dtitle'>
          Punto de observación
        </p>
        
        <div className='dclose'>
          <Icon name='times-circle' className='icon_close' onClick={this.close} />
        </div>
        
        <div style={{alignContent: 'center'}}>
          <div className='nota_title'>
            <TextField
              floatingLabelText='Título'
              floatingLabelFocusStyle={{top: 22}}
              floatingLabelShrinkStyle={{top: 22 }}
              value={this.props.obs.titulo}
              inputStyle={{marginTop: 0, fontSize: 14}}
              style={{height: 50}}
              floatingLabelStyle={{top: 10, fontSize: 14}}
              errorText={this.state.titulo_error}
              errorStyle={{bottom: 5}}
              onChange={this.set_title}
            />
          </div>
          
          <div className='nota_check' onClick={this.change_readonly}>
            <Icon name={this.props.obs.cambios ? 'check-square-o' : 'square-o'} />
            <span>
              Permitir cambios
            </span>
          </div>
          
          <div className='nota_bts'>
            <FlatButton
              label='Cancelar'
              primary={true}
              onContextMenu={no_rclick}
              onClick={this.close}
            />
            
            <FlatButton
              label={this.state.new ? 'Crear' : 'Guardar'}
              primary={true}
              onContextMenu={no_rclick}
              onClick={this.save}
            />
          </div>
        </div>
        
        <div style={{paddingTop: 70, paddingRight: 20, paddingLeft: 20, zIndex: 1000}}>
          <ReactQuill
            value={this.props.obs.nota}
            onChange={this.quill_changed}
            modules={MODULES}
            formats={FORMATS}
            style={{height: 240}}
          />
        </div>
      </div>
    );
  }
  
  
  
  dangerousHTML() {
    return {__html: this.props.obs.nota};
  }
  
  
  
  renderNota(): Element<string> {
    return (
      <div dangerouslySetInnerHTML={this.dangerousHTML()} />
    );
  }
  
  
  
  show_nota_read_only(): Element<string> {
    return (
      <div onContextMenu={no_rclick} className='nota_dialog'>
        <p className='dtitle'>
          Punto de observación
        </p>

        <div className='dclose'>
          <Icon name='times-circle' className='icon_close' onClick={this.close} />
        </div>
        
        <div style={{alignContent: 'center'}}>
          <div className='nota_title' style={{paddingTop: 10}}>
            <b>Título:</b> {this.props.obs.titulo}
          </div>

          <div className='nota_check'>
            <b>Permitir cambios:</b> {this.props.obs.cambios ? 'Si' : 'No'}
          </div>
        </div>

        <div style={{paddingTop: 70, paddingRight: 20, paddingLeft: 20, zIndex: 1000}}>
          <b>Nota:</b> <br />
          <div style={{maxHeight: 350, overflow: 'auto'}}>
            {this.renderNota()}
          </div>
        </div>        
      </div>
    );
  }
  
  
  
  render() {
    const {obs} = this.props.app.state;
    
    if (! this.state.new) {
      if (obs != null && obs.cambios) {
        return this.show_nota();
      }
      else {
        return this.show_nota_read_only();
      }
    }
    else {
      return this.show_nota();
    }
  }
}



// WEBPACK FOOTER //
// ./src/DialogNota.jsx